'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _props = require('./props');

var _template = require('./public/template');

var _template2 = _interopRequireDefault(_template);

var _name = require('./public/name');

var _name2 = _interopRequireDefault(_name);

var _render = require('./public/render');

var _render2 = _interopRequireDefault(_render);

var _nc = require('./ali/nc');

var _nc2 = _interopRequireDefault(_nc);

var _nch = require('./ali/nch5');

var _nch2 = _interopRequireDefault(_nch);

var _version = require('./ali/version');

var _version2 = _interopRequireDefault(_version);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: _name2.default,
  template: _template2.default,
  data: function data() {
    return {
      version: _version2.default,
      nc: null,
      id: (0, _utils.setId)()
    };
  },

  props: _props.mix,
  created: function created() {
    // check install
    if (!window.noCaptcha && !window.NoCaptcha) {
      // install
      (!this.h5 ? _nc2.default : _nch2.default)(this.aeis, this.https);
    }
    // @load
    this.$emit('load');
  },
  mounted: function mounted() {
    var _this = this;

    var getProps = function getProps() {
      var props = _this;
      var lang = props.lang,
          h5 = props.h5;

      var get = function get(name) {
        if ((0, _typeof3.default)(props[name]) === 'object') {
          if (h5) {
            return props[name]['h5'] || function () {
              (0, _utils.warn)('Can not find H5-' + name + ' preset in H5 mode, use PC preset instead.');
              return props[name]['pc'];
            }();
          } else {
            return props[name]['pc'] || function () {
              (0, _utils.warn)('Can not find PC-' + name + ' preset in PC mode, use H5 preset instead.');
              return props[name]['h5'];
            }();
          }
        } else {
          return props[name];
        }
      };
      return {
        appkey: get('appkey'),
        scene: get('scene'),
        h5: h5,
        lang: (0, _utils.getLang)(lang)
      };
    };
    // init

    var _getProps = getProps(),
        appkey = _getProps.appkey,
        scene = _getProps.scene,
        h5 = _getProps.h5,
        lang = _getProps.lang;

    var token = appkey + ':' + new Date().getTime() + ':' + Math.random();
    var noCaptcha = window.noCaptcha || window.NoCaptcha;
    var init = h5 ? noCaptcha.init : noCaptcha;
    var nc = this.nc = init({
      renderTo: '#' + this.id,
      appkey: appkey,
      scene: scene,
      token: token,
      language: lang,
      callback: function callback(_ref) {
        var csessionid = _ref.csessionid,
            sig = _ref.sig;

        _this.$emit('callback', {
          csessionid: csessionid,
          sig: sig,
          token: token,
          scene: scene,
          nc: nc
        });
      },
      error: function error(err) {
        _this.$emit('error', err);
      }
    });
    if (this.h5) {
      noCaptcha.setEnabled(true);
    }
    nc.reset();
  },
  destroyed: function destroyed() {
    if (this.nc && this.nc.destroy) {
      this.nc.destroy();
    }
  },

  render: _render2.default
};